<main class="table-page table-page--fill" dir="rtl">
<header class="header"><div class="title-row">
    <button class="back" type="button" aria-label="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
    <div class="title-block"><h1 class="title">محدوده‌های خودرو</h1></div>
    <div class="actions"><button class="btn-round btn-round-primary" type="button" aria-label="افزودن محدوده" [disabled]="loading" (click)="openArea()" (mouseenter)="pageTooltip.show($event, 'افزودن محدوده')" (mouseleave)="pageTooltip.hide()" (focus)="pageTooltip.show($event, 'افزودن محدوده')" (blur)="pageTooltip.hide()"><i class="fa fa-plus"></i></button></div>
  </div></header>
<section class="card">
    <div class="table-toolbar">
        <label class="search-wrap">
            <input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
                placeholder="جستجو در جدول: نام محدوده، نوع کاربری..." [disabled]="loading">
            <i class="fa fa-search"></i>
        </label>
        <div class="toolbar-actions">
            <button class="btn btn-soft" type="button" ngxPrint [useExistingCss]="true" [printTitle]="tableTitle"
                [printSectionId]="printId" [disabled]="loading || hasError || !filteredRows.length">
                <i class="fa fa-print"></i> چاپ
            </button>
            <button class="btn btn-soft" type="button" (click)="exportExcel()" [disabled]="loading || hasError || !filteredRows.length">
                <i class="fa fa-file-excel-o"></i> خروجی اکسل
            </button>
        </div>
    </div>
    <div class="body">
        <div class="loader" [class.show]="tableLoading" role="status" aria-live="polite">
            <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
        </div>
        <div class="state" [class.show]="!tableLoading && !hasError && !filteredRows.length">
            <div class="ico-big"><i class="fa fa-inbox"></i></div>
            <h4>{{ emptyTitle }}</h4>
            <span class="muted">{{ hasActiveFilters ? 'فیلترها را تغییر دهید و دوباره جستجو کنید.' : 'هنوز اطلاعاتی ثبت نشده است.' }}</span>
            <div class="empty-actions" *ngIf="hasActiveFilters">
                <button class="btn btn-primary" type="button" [disabled]="loading" (click)="clearSearch()"><i class="fa fa-undo"></i> حذف فیلترها</button>
            </div>
        </div>
        <div class="state error" [class.show]="!tableLoading && hasError">
            <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
            <h4>دریافت اطلاعات با خطا مواجه شد</h4>
            <span class="muted">{{ errorMessage }}</span>
            <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="getPastArea()"><i class="fa fa-refresh"></i> تلاش مجدد</button>
        </div>
        <div class="table-scroll" *ngIf="!hasError && filteredRows.length" [hidden]="tableLoading" (scroll)="pageTooltip.hide()">
            <ng-container [ngTemplateOutlet]="recordsTable"
                [ngTemplateOutletContext]="{ data: pagedRows, offset: (currentPage - 1) * pageSize, printing: false }"></ng-container>
        </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length"
        [pageSizeOptions]="pageSizeOptions" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
</section>
<div class="print-only" [id]="printId" *ngIf="!tableLoading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl">
        <h1 class="title">{{ tableTitle }}</h1>
        <ng-container [ngTemplateOutlet]="recordsTable"
            [ngTemplateOutletContext]="{ data: filteredRows, offset: 0, printing: true }"></ng-container>
    </div>
</div>
<ng-template #recordsTable let-data="data" let-offset="offset" let-printing="printing">
            <table>
                <thead>
                    <tr>
                        <th *ngIf="!printing" class="col-ops sticky-first">عملیات</th>
                        <th class="col-num">#</th>
                        <th>نام محدوده</th>
                        <th>نوع کاربری</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i = index">
                        <td *ngIf="!printing" class="col-ops sticky-first">
                            <div class="row-ops">
                                    <button class="ico" type="button" [disabled]="loading" aria-label="حذف محدوده" data-tip="حذف محدوده"
                                        (mouseenter)="pageTooltip.show($event, 'حذف محدوده')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'حذف محدوده')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); onRecordAction('delete', row)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                            </div>
                        </td>
                        <td class="col-num">{{ offset + i + 1 | faNum }}</td>
                        <td>{{ row.strTitle | faNum }}</td>
                        <td>{{ row.strGeoFenceUsgae_strComment | faNum }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td *ngIf="!printing" class="sticky-first"></td>
                        <td class="label" colspan="3">تعداد کل: {{ filteredRows.length | number | faNum }}</td>

                    </tr>
                </tfoot>
            </table>
</ng-template>
  <div class="modal fade rtl" id="carAreaModal" tabindex="-1" aria-labelledby="carAreaModalTitle" aria-describedby="carAreaModalHint" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header align-items-start">
          <div>
            <h2 class="modal-title" id="carAreaModalTitle">تعیین محدودهٔ خودرو</h2>
            <p class="muted mb-0 mt-2" id="carAreaModalHint">محدوده، کاربری و بازهٔ زمانی آن را مشخص کنید.</p>
          </div>
          <button class="btn-close p-3" type="button" data-bs-dismiss="modal" aria-label="بستن"></button>
        </div>
        <div class="modal-body" [attr.aria-busy]="loading">
          <fieldset class="border-0 p-0 m-0" [formGroup]="saveGeoFence" [disabled]="loading">
            <div class="row g-3 mb-4">
              <label class="field col-12 col-md-6" for="carAreaFence">
                <span class="field-label">نام محدوده</span>
                <select id="carAreaFence" class="control" formControlName="iGeoFence">
                  <option [ngValue]="-1">انتخاب محدوده</option>
                  <option *ngFor="let item of GeoFenceData" [ngValue]="item.iGeoFence">{{ item.strTitle }}</option>
                </select>
              </label>
              <label class="field col-12 col-md-6" for="carAreaUsage">
                <span class="field-label">کاربری</span>
                <select id="carAreaUsage" class="control" formControlName="tiGeoFenceUsgae">
                  <option [ngValue]="-1">انتخاب کاربری</option>
                  <option *ngFor="let item of geoFenceUsgae" [ngValue]="item.tiGeoFenceUsgae">{{ item.strComment }}</option>
                </select>
              </label>
              <label class="field col-12 col-md-6" for="Stime">
                <span class="field-label">از ساعت</span>
                <input class="control" type="time" id="Stime" formControlName="strSTime">
              </label>
              <label class="field col-12 col-md-6" for="Etime">
                <span class="field-label">تا ساعت</span>
                <input class="control" type="time" id="Etime" formControlName="strETime">
              </label>
            </div>
            <section class="bg-light border rounded-3 p-3" aria-labelledby="carAreaNotifications">
              <h3 class="h6 mb-2" id="carAreaNotifications">اطلاع‌رسانی</h3>
              <p class="muted mb-3">روش‌های دریافت اعلان مربوط به این محدوده را انتخاب کنید.</p>
              <div class="d-flex flex-column gap-3">
                <label class="d-flex align-items-center gap-2" for="carAreaSms"><input type="checkbox" id="carAreaSms" formControlName="bSendSMS"> ارسال پیامک</label>
                <label class="d-flex align-items-center gap-2" for="carAreaPush"><input type="checkbox" id="carAreaPush" formControlName="bSendPush"> ارسال هشدار</label>
              </div>
            </section>
          </fieldset>
          <p *ngIf="loading" class="muted mt-3 mb-0" role="status" aria-live="polite">در حال پردازش محدودهٔ خودرو…</p>
        </div>
        <div class="modal-footer gap-2">
          <button class="btn btn-ghost" type="button" data-bs-dismiss="modal">بستن</button>
          <button class="btn btn-primary" type="button" [disabled]="loading" (click)="SaveMobileGeoFence()">ثبت</button>
        </div>
      </div>
    </div>
  </div>
  <app-table-tooltip #pageTooltip></app-table-tooltip>
</main>
